import {
  Form,
  InputNumber,
  type FormItemProps,
  type InputNumberProps,
} from "antd";

interface Props extends FormItemProps {
  inputProps?: InputNumberProps;
  notFormatter?: boolean;
}

export default function FormItemInputNumber({
  inputProps,
  notFormatter = true,
  ...rest
}: Props) {
  const faToEnNumber = (str: string) => {
    return str.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d).toString());
  };
  return (
    <Form.Item {...rest} className="mb-0!">
      <InputNumber
        min={0}
        formatter={(value) =>
          notFormatter && value !== undefined && value !== ""
            ? Intl.NumberFormat("en", { maximumFractionDigits: 20 }).format(
                Number(value),
              )
            : ""
        }
        parser={(value) => {
          if (!notFormatter || !value) return "";
          const english = faToEnNumber(value);
          return english.replace(/[$,]/g, "") as unknown as number;
        }}
        stringMode
        className="w-full!"
        {...inputProps}
      />
    </Form.Item>
  );
}
